interface Inputs {
  /** −1..1; sign picks forward vs retro nozzles. */
  throttle: number;
  steer: number;
  strafe: number;
  fire1: boolean;
  /** Rising-edge: one-frame pulse. */
  toggleFireMode: boolean;
  toggleAutoBrake: boolean;
}

export class InputState {
  private keys = new Set<string>();
  private justPressed = new Set<string>();

  constructor(target: HTMLElement | Window = window) {
    target.addEventListener("keydown", (e: Event) => {
      const ev = e as KeyboardEvent;
      if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", " "].includes(ev.key)) {
        ev.preventDefault();
      }
      // First keydown only (browsers repeat while held).
      if (!this.keys.has(ev.code)) {
        this.justPressed.add(ev.code);
      }
      this.keys.add(ev.code);
    });
    target.addEventListener("keyup", (e: Event) => {
      const ev = e as KeyboardEvent;
      this.keys.delete(ev.code);
    });
    target.addEventListener("blur", () => {
      this.keys.clear();
      this.justPressed.clear();
    });
  }

  read(): Inputs {
    const k = this.keys;
    let throttle = 0;
    if (k.has("KeyW") || k.has("ArrowUp"))   throttle += 1;
    if (k.has("KeyS") || k.has("ArrowDown")) throttle -= 1;

    let steer = 0;
    if (k.has("KeyA") || k.has("ArrowLeft")) steer -= 1;
    if (k.has("KeyD") || k.has("ArrowRight")) steer += 1;

    let strafe = 0;
    if (k.has("KeyQ")) strafe -= 1;
    if (k.has("KeyE")) strafe += 1;

    const toggleFireMode =
      this.justPressed.has("ShiftLeft") || this.justPressed.has("ShiftRight");
    const toggleAutoBrake = this.justPressed.has("KeyB");
    this.justPressed.clear();

    return {
      throttle,
      steer,
      strafe,
      fire1: k.has("Space"),
      toggleFireMode,
      toggleAutoBrake,
    };
  }
}
